import { render, staticRenderFns } from "./ProposalTableLineItem.vue?vue&type=template&id=53f9b276&"
import script from "./ProposalTableLineItem.vue?vue&type=script&lang=js&"
export * from "./ProposalTableLineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports